
/**
 * 간단 성공 응답
 */
export type EnrollCourse201 = {
  /** 성공 여부 */
  success: boolean;
};
